import { PurchasedProductInterface } from 'outshared-lib';
import { CoverageGroupTypeEnum } from '../enums';
import { CoverageControlConfigGroupInterface } from '../interfaces';
import { CoverageGroupAbstract } from './coverage-group.abstract';

export class CoverageGroupRadio extends CoverageGroupAbstract {
    constructor(
        group: CoverageControlConfigGroupInterface,
        purchasedProduct: PurchasedProductInterface,
    ) {
        super(CoverageGroupTypeEnum.Radio, group, purchasedProduct);
    }
}
